import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-cp-member-home',
  templateUrl: './cp-member-home.component.html',
  styleUrls: ['./cp-member-home.component.scss'],
})
export class CpMemberHomeComponent implements OnInit {
  noNomineeAdded = false;
  constructor(private router: Router, private tracking: TrackingService) {}

  ngOnInit() {}

  navigateToClaims(){
    this.tracking.pushEvent("start_or_track_claim", {});
    this.router.navigate(['cp-member/claims']);
  }

  redirectToManageProfile(){
    this.router.navigate(['/cp-member/manage-profile']);

  }

  showAddNomineeBaner(event){
    this.noNomineeAdded = event;
  }

  redirectToContactUs(){
    this.tracking.pushEvent("contact_us", {});
    this.router.navigate(['/cp-member/contact']);
  }

}
